export enum AddProductAnalyticsEntryPoint {
  CATALOG_PRODUCT_CARD = "CatalogPage_ProductCard_AddProduct",
  CATALOG_PAGE_PRODUCT_DROPDOWN = "CatalogPage_ProductDropdown_AddProduct",
  TREATMENT_PLAN_PAGE = "TreatmentPlanPage_AddProduct",
  PROTOCOL_PAGE = "ProtocolPage_AddProduct",
  PRODUCT_DETAILS_PAGE_OTHER_OPTION = "ProductDetailsPage_OtherOption",
  PRODUCT_DETAILS_PAGE_OTHER_OPTIONS_PRODUCT_CARD = "ProductDetailsPage_OtherOptions_ProductCard",
  CARE_CENTER_PRODUCT_DETAILS_PAGE = "CareCenter_ProductDetailsPage",
  PRODUCT_DETAILS_PAGE = "ProductDetailsPage",
  CARE_CENTER_CATALOG_PAGE_PRODUCT_CARD = "CareCenterCatalogPage_ProductCard",
  WHOLE_PERSON_PLAN_PRODUCT_CARD = "WholePersonPlan_ProductCard",
  CATEGORY_PAGE_TEMPLATE = "CategoryPage_Template_AddProduct",
  CATEGORY_PAGE_POPULAR_PRODUCTS_CARD = "CategoryPage_PopularProducts_ProductCard",
  CATEGORY_PAGE_TOP_PICK_CARD = "CategoryPage_TopPick_ProductCard",
}

export enum RemoveProductFromComparisonEntryPoint {
  CARE_CENTER_CATALOG_PAGE_PRODUCT_CARD = "CareCenterCatalogPage_ProductCard",
  CARE_CENTER_PRODUCT_DETAILS_PAGE = "CareCenter_ProductDetailsPage",
  COMPARE_EVERYWHERE_BAR = "Compare_Everywhere_Bar",
  COMPARISON_TABLE = "Comparison_Table",
}

export enum Ten99KEDeliveryEntryPoint {
  TAX_VERIFICATION_MODAL = "Modal",
  FINANCIAL_REPORTS_PAGE = "FinancialReports",
}

export enum ShowcaseOnMyWebsiteEntryPoint {
  CATALOG_PRODUCT_CARD = "Catalog_ProductCard",
  POPULAR_PRODUCT_CARD = "Popular_ProductCard",
  SIMILAR_PRODUCT_CARD = "Similar_ProductCard",
  RECENTLY_VIEWED_PRODUCT_CARD = "RecentlyViewed_ProductCard",
  NEW_ON_FULLSCRIPT_PRODUCT_CARD = "NewOnFullScript_ProductCard",
  PRODUCT_DESCRIPTION_PAGE = "ProductDescriptionPage",
  WHOLESALE_ORDER_SUMMARY = "WholesaleOrder_Summary_OrderItem",
}

export enum NewTreatmentPlanEntryPoint {
  CATALOG_PAGE_PRODUCT_DROPDOWN = "CatalogPage_ProductDropdown_TreatmentPlanNew",
  CATALOG_HEADER = "CatalogPage_HeaderButton_TreatmentPlanNew",
  SIDENAV = "SideNav_TreatmentPlanNew",
  TOPNAV_DROPDOWN = "TopNav_DropdownTreatmentPlanNew",
  TOPNAV = "TopNav_TreatmentPlanNew",
  TOPNAV_MAIN_CTA = "TopNav_TreatmentPlanNew_MainCTA",
  ONBOARDING_MODAL_ALLSET = "OnboardingModal_AllSet_TreatmentPlanNew",
  DISPENSING_CHECKLIST = "DispensingChecklist_TreatmentPlanNew",
  QUICK_START_MENU = "QuickStartMenu_TreatmentPlanNew",
  PRACTITIONER_GRID = "PractitionerGrid_TreatmentPlanNew",
  CATALOG_PRODUCT_CARD = "Catalog_ProductCard_TreatmentPlanNew",
  PATIENTS_LIST_PAGE = "PatientsListPage_TreatmentPlanNew",
  PATIENT_PAGE_HEADER = "PatientPageHeader_TreatmentPlanNew",
  PATIENT_PAGE_HEADER_BUTTON_TEMPLATES = "PatientPageHeader_TreatmentPlanNew_ButtonTemplates",
  PATIENT_PAGE_HEADER_BUTTON_SUPPLEMENTS = "PatientPageHeader_TreatmentPlanNew_ButtonSupplements",
  PATIENT_PAGE_HEADER_BUTTON_LABS = "PatientPageHeader_TreatmentPlanNew_ButtonLabs",
  PATIENT_PAGE_PRESCRIPTIONS_EMPTY_STATE = "PatientPage_PrescriptionsEmptyState_TreatmentPlanNew",
  PATIENT_PAGE_ORDERS_EMPTY_STATE = "PatientPage_OrdersEmptyState_TreatmentPlanNew",
  PATIENT_CREATED_MODAL = "PatientCreatedModal_TreatmentPlanNew",
  IMPORT_IN_PROGRESS = "ImportInProgress_TreatmentPlanNew",
  RECENT_ORDERS_PAGE = "RecentOrdersPage_TreatmentPlanNew",
  WHATS_NEW_MODAL_CREATE_PATIENT = "WhatsNewModal_CreatePatient_TreatmentPlanNew",
  INSIGHTS_PAGE_GET_STARTED = "InsightsPage_GetStarted",
  PATIENT_START_PAGE = "PatientStartPage_TreatmentPlanNew",
  HOME_PAGE_BUILD_PLAN = "HomePage_BuildPlan_TreatmentPlanNew",
  BUILD_PLANS_PAGE = "BuildPlansPage",
  PLANS_PAGE = "PlansPage",
  FULLSCRIPT_ASSIST = "FullscriptAssist",
  FULLSCRIPTJS_PATIENT_LIST_PAGE = "FullscriptJsPatientListPage",
  FULLSCRIPTJS_EXTERNAL = "FullscriptJsExternal",
}

export enum AddItemToDailyPackEntryPoint {
  PILL_PDP = "PillPDP",
  TEMPLATE_PDP = "TemplatePDP",
  PILL_CARD = "PillCard",
  TEMPLATE_CARD = "TemplateCard",
  PILL_LIST_TEMPLATE_PDP = "PillListTemplatePDP",
}

export enum SaveDailyPackAsTemplateEntryPoint {
  ADD_TO_PLAN = "AddToPlan",
  SAVE_AS_TEMPLATE = "SaveAsTemplate",
}

export enum EditPlanEntryPoint {
  PLANS_PAGE = "PlansPage",
  PATIENT_PAGE = "PatientPage",
  INDIVIDUAL_PLAN_PREVIEW = "IndividualPlanPreview",
}

export enum NewProtocolEntryPoint {
  TOPNAV_DROPDOWN_NEW_PROTOCOL = "TopNav_DropdownNewProtocol",
  HANG_TIGHT_NEW_PROTOCOL = "HangTight_NewProtocol",
  ONBOARDING_MODAL_ALLSET_NEW_PROTOCOL = "OnboardingModal_AllSet_NewProtocol",
  QUICK_START_MENU_NEW_PROTOCOL = "QuickStartMenu_NewProtocol",
  PROTOCOLS_FOOTER_NEW_PROTOCOL = "ProtocolsFooter_NewProtocol",
  PROTOCOLS_BOX_DEMO_NEW_PROTOCOL = "ProtocolsBox_Demo_NewProtocol",
  PROTOCOLS_EMPTY_STATE_NEW_PROTOCOL = "ProtocolsEmptyState_NewProtocol",
  PROTOCOLS_PAGE_NEW_PROTOCOL = "ProtocolsPage_NewProtocol",
}

export enum PillPackEntryPoint {
  DASHBOARD_BANNER = "PillPack_Dashboard_Banner",
  CATALOG_BANNER = "PillPack_RXCatalog_Banner",
  PROTOCOLS_BANNER = "PillPack_Protocols_Banner",
}

export enum ProtocolModalEntryPoint {
  FULLSCRIPT_PROTOCOLS = "FullscriptProtocols",
  SHARED_PROTOCOLS = "SharedProtocols",
  MY_PROTOCOLS = "MyProtocols",
  CATEGORY_PAGE = "CategoryPage",
}

export enum ActivateProtocolEntryPoint {
  PROTOCOLS_NEWPROTOCOL = "Protocols_NewProtocol_MainCTA",
  TREATMENTPLANS_SAVEASPROTOCOL = "TreatmentPlans_SaveAsProtocol_ModalCTA",
  TREATMENTPLANS_INSIGHTS = "TreatmentPlans_Insights_DropdownCTA",
  PATIENTS_TREATMENTPLANS = "Patients_TreatmentPlans_DropdownCTA",
}

export enum AttachDocumentEntryPoint {
  TREATMENT_PLAN_CATALOG_DRAWER = "TreatmentPlan_Catalog_Drawer",
  TREATMENT_PLAN_CATALOG_DRAWER_PATIENT_HISTORY = "TreatmentPlan_CatalogDrawer_PatientHistory",
  TREATMENT_PLAN_RESOURCE_MODAL = "TreatmentPlan_ResourceModal",
  TREATMENT_PLAN_RESOURCE_MODAL_UPLOAD = "TreatmentPlan_ResourceModal_Upload",
  TREATMENT_PLAN_PROTOCOL_MODAL_VIEW_PROTOCOL = "TreatmentPlan_ProtocolModal_ViewProtocol",
  TREATMENT_PLAN_AUTOSHIP_RESOURCE_MESSAGE = "TreatmentPlan_AutoshipResourceMessage",
  TREATMENT_PLAN_CATALOG_DRAWER_RESOURCES = "TreatmentPlan_CatalogDrawer_Resources",
  CARE_CENTER = "CareCenter",
}

export enum AttachSnippetEntryPoint {
  MODAL = "Modal",
  TEXTBOX = "TextBox",
}

export enum NewPatientEntryPoint {
  TOPNAV_PATIENTS_NEW = "TopNav_Patients_New",
  TOP_SEARCH_BAR = "TopSearchBar_CreatePatient",
  TOPNAV_DROPDOWN = "TopNav_Dropdown_CreateNewPatient",
  ONBOARDING_MODAL_ALL_SET = "OnboardingModal_AllSet_PatientsNew",
  SIDENAV = "SideNav_PatientsNew",
  PATIENTS_PAGE_CREATE_FIRST_PATIENT = "PatientsPage_CreateFirstPatient",
  STORE_INSIGHTS = "StoreInsights_AddPatient",
  QUICK_START_MENU = "QuickStart_Menu_CreatePatient",
  PATIENT_PAGE = "PatientPage_NewPatient",
  START_TREATMENT_PLAN_PATIENT_MODAL_CREATE_FIRST_PATIENT = "StartTreatmentPlan_PatientModal_CreateFirstPatient",
  DISPENSING_CHECKLIST_ADD_FIRST_PATIENT = "DispensingChecklist_AddFirstPatient",
  PATIENT_PAGE_SEARCH_EMPTY_STATE = "PatientPageSearch_EmptyState_CreatePatient",
  TREATMENT_PLAN_TITLE = "TreatmentPlan_Title_CreatePatient",
  TREATMENT_PLAN_SEARCH_DROPDOWN = "TreatmentPlan_SearchDropdown_CreatePatient",
  PATIENT_START_PAGE = "PatientStartPage_NewPatient",
  CARE_CENTER_PATIENT_PANEL = "CareCenter_PatientPanel_CreatePatientStart",
  PLAN_REVIEW_CREATE_PATIENT = "PlanReview_CreatePatient",
}

export enum OptimizedMegaMenuEntryPoint {
  DTP_CATALOG_PAGE = "DTPCatalogPage",
  WHOLESALE_CATALOG_PAGE = "WholesaleCatalogPage",
}

export enum SearchApplyEntryPoint {
  CATALOG_PAGE = "CatalogPage",
  CARE_CENTER_CATALOG_PAGE = "CareCenterCatalogPage",
  WHOLESALE_CATALOG_PAGE = "WholesaleCatalogPage",
  CATALOG_LANDING_PAGE = "CatalogLandingPage",
  TREATMENT_PLAN_PAGE = "TreatmentPlanPage",
}

export enum LabSearchApplyEntryPoint {
  CATALOG_PAGE = "CatalogPage",
  PANELS_PAGE = "PanelsPage",
  WHOLESALE_LAB_KITS_PAGE = "WholesaleLabKitsPage",
}

export enum AddLabKitToCartEntryPoint {
  WHOLESALE_LAB_KITS_PAGE = "WholesaleLabKitsPage",
  INVENTORY_LIMIT_REACHED_MODAL = "InventoryLimitReachedModal",
  LAB_KIT_DETAILS_PAGE = "LabKitDetailsPage",
}

export enum LabViewTestDescriptionEntryPoint {
  TEST_DETAILS_PAGE = "TestDetailsPage",
  CATALOG_SEARCH_RESULTS = "SearchResultsPage",
  CUSTOM_PANEL = "PanelTestsIncludedSection",
  PLAN_VIEW = "PlanReviewPage",
  INCLUDED_ADDONS = "AddonsSection",
  POPULARITY = "PopularityLabsSection",
}

export enum LabViewSentTestDetailsEntryPoint {
  ORDER_DETAILS_PAGE = "OrderDetailsPage",
  PATIENT_PAGE_ORDERS_SECTION = "PatientPageOrdersSection",
  RECENT_ORDERS_PAGE = "RecentOrdersPage",
  PATIENT_PAGE_PLANS_SECTION = "PatientPagePlansSection",
  PATIENT_PAGE_LABS_SECTION = "PlanPageLabsSection",
}

export enum ViewProductEntryPoint {
  CATALOG_PAGE = "CatalogPage",
  TREATMENT_PLAN_PAGE = "TreatmentPlanPage",
  PRODUCT_DETAILS_PAGE = "ProductDetailsPage",
  CARE_CENTER_PRODUCT_DETAILS_PAGE = "CareCenter_ProductDetailsPage",
  PATIENT_PAGE_TREATMENT_PLANS_PRODUCT_CARD = "PatientPage_TreatmentPlans_ProductCard",
  PATIENT_PAGE_ORDERS_PRODUCT_CARD = "PatientPage_Orders_ProductCard",
  SWAPS_NEEDED_PAGE_PRODUCT_CARD = "SwapsNeededPage_ProductCard",
  FULLSCRIPT_PROTOCOL_PAGE_PRODUCT_CARD = "FullsriptProtocolPage_ProductCard",
  FAVORITES_PAGE = "FavoritesPage",
  PATIENT_ORDERS_PAGE_PRODUCT_CARD = "PatientOrdersPage_ProductCard",
  ORDER_PAGE_LINE_ITEM = "OrderPage_LineItem",
  ORDER_PAGE_SHIPMENTS = "OrderPage_Shipments",
  TREATMENT_PLAN_PRODUCT_CARD = "TreatmentPlan_ProductCard",
  NEW_ON_FULLSCRIPT_PRODUCT_CARD = "NewOnFullScript_ProductCard",
  POPULAR_PRODUCT_CARD = "Popular_ProductCard",
  SIMILAR_PRODUCT_CARD = "Similar_ProductCard",
  RECOMMENDED_TOGETHER_PRODUCT_CARD = "Recommended_Together_ProductCard",
  SMART_SUGGESTIONS_SECTION_PRODUCT_CARD = "SmartSuggestionsSection_ProductCard",
  RECENTLY_VIEWED_PRODUCT_CARD = "RecentlyViewed_ProductCard",
  PROTOCOL_PRODUCT_CARD = "Protocol_ProductCard",
  PATIENT_HISTORY_PRODUCT_CARD = "PatientHistory_ProductCard",
  FREQUENTLY_PRESCRIBED_PRODUCT_CARD = "FrequentlyPrescribed_ProductCard",
  PRODUCT_DETAILS_PAGE_OTHER_OPTIONS_PRODUCT_CARD = "ProductDetailsPage_OtherOptions_ProductCard",
  PRODUCT_DETAILS_PAGE_OTHER_OPTION = "ProductDetailsPage_OtherOption",
  CATALOG_TYPE_AHEAD = "Catalog_TypeAhead",
  CARE_CENTER_TYPE_AHEAD = "CareCenter_TypeAhead",
  CARE_CENTER_CATALOG_PAGE_PRODUCT_CARD = "CareCenterCatalogPage_ProductCard",
  CARE_CENTER_RX_SUMMARY_BAR_PRODUCT_TAG = "CareCenter_RxSummaryBar_ProductTag",
  CARE_CENTER_FAVORITES_PAGE_PRODUCT_CARD = "CareCenter_FavoritesPage_ProductCard",
  CARE_CENTER_REVIEW_PLAN_HOVER = "CareCenter_ReviewPlan_Hover",
  PATIENT_PAGE_CURRENTLY_TAKING = "PatientPage_CurrentlyTaking",
  TREATMENT_PLAN_CURRENTLY_TAKING = "TreatmentPlan_CurrentlyTaking",
  PLAN_TOOLBAR_CURRENTLY_TAKING = "PlanToolbar_CurrentlyTaking",
  ACTIVE_SWAP_PAGE_INDIVIDUAL_CURRENTLY_TAKING = "ActiveSwapPage_Individual_CurrentlyTaking",
  CARE_ENTER_SMART_PLAN_BUILDER = "CareCenter_SmartPlanBuilder",
  CATEGORY_PAGE = "CategoryPage",
}

export enum ViewAlternativeProductsEntryPoint {
  PRODUCT_DETAILS_PAGE = "ProductDetailsPage",
  COMPARE_EVERYWHERE_BAR = "CompareEverywhereBar",
  SMART_SUGGESTIONS_SECTION = "SmartSuggestionsSection",
}

export enum CreatePatientEntryPoint {
  NEW_PATIENT_PAGE = "NewPatientPage_CreatePatient",
  TREATMENT_PLAN_NEW_PATIENT_MODAL = "TreatmentPlan_NewPatientModal_CreatePatient",
  CARE_CENTER_PATIENT_PANEL = "CareCenter_PatientPanel_CreatePatientComplete",
  FULLSCRIPTJS_CREATE_NEW_PATIENT = "FullscriptJs_CreateNewPatient",
}

export enum NavigateToPlanPageEntryPoint {
  NAV = "Nav_NavigateToPlanPage",
  TEMPLATE_BUILD = "TemplateBuild_NavigateToPlanPage",
  BUILD_PLAN = "BuildPlan_NavigateToPlanPage",
}

export enum NewStaffEntryPoint {
  STAFF_PAGE_STAFF_NEW = "StaffPage_StaffNew",
  PRACTITIONER_PAGE_PRACTITIONER_NEW = "PractitionerPage_PractitionerNew",
}

export enum CheckoutStartEntryPoint {
  CART_DROPDOWN_HEADER = "TopNav_CartDropdown_Header",
  CART_DROPDOWN_GO_TO_CHECKOUT = "TopNav_CartDropdown_GoToCheckout",
  CATALOG_PRODUCT_CARD = "Catalog_ProductCard_ViewCart",
}

export enum InOfficeViewCartEntryPoint {
  GENERIC_PATIENT_BASKET = "PatientPageHeader_PatientBasket",
  TREATMENT_PLAN_LIST_PATIENT_BASKET = "TreatmentPlanList_PatientBasket",
  TREATMENT_PLAN_PATIENT_BASKET = "TreatmentPlan_PatientBasket",
  PATIENT_EDIT_PATIENT_BASKET = "PatientEdit_PatientBasket",
  ORDER_LIST_PATIENT_BASKET = "OrderList_PatientBasket",
  ORDER_PATIENT_BASKET = "Order_PatientBasket",
  PATIENT_PAGE_PATIENT_BOX = "PatientPage_PatientBox",
  TREATMENT_PLAN_FOOTER_MODAL = "TreatmentPlan_PopulateOrder",
}

export enum OpenOnboardingModalEntryPoint {
  BANNER = "banner",
  CHECKLIST_STEP = "checklist_step",
  DROPDOWN = "dropdown",
  MESSAGE_BOX = "message_box",
  NEW_CHECKLIST = "new_checklist",
  NEW_CHECKLIST_STEP = "new_checklist_step",
  PRACTITIONER_BOX = "practitioner_box",
  RX_SENT = "rx_sent",
}

export enum SignupEntryPoint {
  CERTIFICATE = "certificate",
  COMPLETE = "complete",
  STUDENT_IDENTIFICATION = "student_identification",
  ADDITIONAL_VERIFICATION = "additional_verification",
  NPI_CONFIRMATION = "npi_confirmation",
}

export enum NavigateToReferralsPageEntryPoint {
  DROPDOWN_MENU = "DropdownMenu",
  WHATS_NEW_CAROUSEL = "WhatsNewCarousel",
  DISPENSARY_SETTINGS_PAGE_TEXT_BOX = "DispensarySettingsPageTextBox",
  FINANCIAL_REPORTS_BANNER = "FinancialReportsBanner",
  DISPENSARY_SETTINGS_PAGE_TOOLTIP = "DispensarySettingsPageTooltip",
  WHATS_NEW_BASE_CARD_HOME_PAGE = "WhatsNewBaseCardHomePage",
  WHATS_NEW_ACCENT_CARD_HOME_PAGE = "WhatsNewAccentCardHomePage",
}

export enum LabsStartSetupEntryPoint {
  PATIENT_PAGE_LABS_TAB_COMPLETE_SETUP = "PatientPage_LabsTab_CompleteSetup",
  PATIENT_PAGE_LABS_TAB_SEE_TERMS_OF_SERVICE = "PatientPage_LabsTab_SeeTermsOfService",
}

export enum LabsLaunchEntryPoint {
  DASHBOARD_LAB_RECOMMENDATION = "Dashboard_LabRecommendation",
  TOPNAV_NEW_PRESCRIPTION_CREATE_LAB_RECOMMENDATION = "TopNav_NewPrescription_CreateLabRecommendation",
}

export enum ReferralReferPractitionerEntryPoint {
  EMPTY_REFERRALS_LIST_CARD = "EmptyReferralsListCard",
  REFERRALS_LIST_CTA = "ReferralListCTA",
}

export enum VerifyTaxModalEntryPoint {
  BANNER = "Banner",
  NOTIFICATION = "Notification",
}

export enum LabsJourneyEntryPoint {
  PRODUCT_DETAILS_PAGE = "ProductDetailsPage",
  TREATMENT_PLAN_PLAN_REVIEW = "TreatmentPlan_PlanReview",
}

export enum LabsInterpretationEntryPoint {
  LAB_RECOMMENDATION_DETAILS_PAGE = "LabRecommendationDetailsPage",
  LAB_INTERPRETATION_DOWNLOAD_RESULTS_MODAL = "LabInterpretationDownloadResultsModal",
}

export enum PayoutsPageEntryPoint {
  DISPENSARY_SETTINGS_PAYOUTS_AND_TAX_SWITCH_TO_PROFIT_ACCOUNT = "DispensarySettings_PayoutsAndTax_SwitchToProfitAccount",
  DISPENSARY_SETTINGS_STORE_MARGIN_PAYOUTS_AND_TAX_TAB = "DispensarySettings_StoreMargin_PayoutsAndTaxTab",
  PAYOUTS_DISABLED_NOTIFICATION = "PayoutsDisabledNotification",
  PAYOUTS_PAUSED_BAR = "PayoutsPausedBar",
  ADDITIONAL_INFO_BAR = "AdditionalInfoBar",
}

export enum PaymentsPageEntryPoint {
  PRACTITIONER_NAV_SETUP_MARGIN_ACCOUNT_BUTTON = "PractitionerNav_SetupMarginAccountButton",
  DISPENSARY_SETTINGS_PAYMENTS_PAGE_STORE_MARGIN_TAB = "DispensarySettings_PaymentsPage_StoreMarginTab",
  DISPENSARY_SETTINGS_LINK = "DispensarySettingsLink",
  DISPENSING_CHECKLIST = "DispensingChecklist",
  ACCOUNT_COMPLETE_MODAL = "AccountCompleteModal",
}

export enum WellevateMigrationEntryPoint {
  DATA_IMPORT_BANNER = "DataImportBanner",
  PRACTITIONER_MENU = "PractitionerMenu",
}

export enum CloseDrawerEntryPoint {
  CLOSE_DRAWER_BUTTON = "Drawer_CloseDrawerButton",
  OUTSIDE_DRAWER = "Drawer_OutsideDrawer",
  REVIEW_PLAN_BUTTON = "Drawer_ReviewPlanButton",
}

export enum IOCAddToCartEntryPoint {
  PATIENT_HISTORY = "PatientHistory",
  TREATMENT_PLAN = "TreatmentPlan",
  CATALOG = "Catalog",
}

export enum TreatmentPlanAccessModelEntryPoint {
  TREATMENT_PLAN = "TreatmentPlan",
}

export enum ViewPlanEntryPoint {
  SHARED_MULTI_PATIENT_PLANS = "SharedMultiPatientPlans",
  SHARED_TREATMENT_PLAN_TEMPLATES = "SharedTreatmentPlanTemplates",
  FULLSCRIPT_TEMPLATES = "FullscriptTemplates",
  INDIVIDUAL_PLANS_PAGE = "IndividualPlansPage",
  EXPLORE_PAGE = "ExplorePage",
  ACTIVE_SWAP_PAGE_INDIVIDUAL = "ActiveSwapPage_Individual",
  ACTIVE_SWAP_PAGE_MULTIPATIENT = "ActiveSwapPage_MultiPatient",
}

export enum TreatmentPlanCopyLinkEntryPoint {
  MULTI_PATIENT_ACCESS = "MultiPatientAccess",
  INDIVIDUAL_PLAN_SUCCESS_BANNER = "IndividualPlanSuccessBanner",
  MULTI_PATIENT_PLAN_SUCCESS_BANNER = "MultiPatientPlanSuccessBanner",
  PATIENT_PLANS_PAGE = "PatientPlansPage",
  MULTI_PATIENT_PLAN_PREVIEW = "MultiPatientPlanPreview",
  INDIVIDUAL_PLAN_PREVIEW = "IndividualPlanPreview",
}

export enum TreatmentPlanDeleteEntryPoint {
  TEMPLATE_PREVIEW = "TemplatePreview",
  MULTI_PATIENT_PLAN_PREVIEW = "MultiPatientPlanPreview",
  PATIENT_PROFILE_PLAN_KEBAB = "PatientProfilePlanKebab",
}

export enum BrandAgreementEntryPoint {
  PRODUCT_CARD = "ProductCard",
  PRODUCT_DETAILS_PAGE = "ProductDetailsPage",
  BRAND_AGREEMENTS_PAGE = "BrandAgreementsPage",
  ORDER_PAGE = "OrderPage",
  QUICK_ORDER = "QuickOrder",
  QUICK_VIEW = "QuickView",
}

export enum StartUpgradeEntryPoint {
  HOME_BANNER = "HomeBanner",
  TOP_BANNER = "TopBanner",
  WHATS_NEW_BANNER = "WhatsNewBanner",
}

export enum EHRDashboardEntryPoint {
  EHR_CARD = "ehr_card",
}

export enum TreatmentPlanDocumentEntryPoint {
  ATTACHMENT_TAG = "AttachmentTag",
  FULLSCRIPT_CONTENT_CARD_NAME = "FullscriptContentCard_Name",
  FULLSCRIPT_CONTENT_CARD_PHOTO = "FullscriptContentCard_Photo",
  FULLSCRIPT_CONTENT_CARD_VIEW_LINK = "FullscriptContentCard_ViewLink",
  FULLSCRIPT_PATIENT_RESOURCE_CARD_NAME = "FullscriptPatientResourceCard_Name",
  FULLSCRIPT_PATIENT_RESOURCE_CARD_PHOTO = "FullscriptPatientResourceCard_Photo",
  FULLSCRIPT_PATIENT_RESOURCE_CARD_VIEW_LINK = "FullscriptPatientResourceCard_ViewLink",
  MY_UPLOAD_NAME = "MyUpload_Name",
  MY_UPLOAD_VIEW_LINK = "MyUpload_ViewLink",
  OPEN_DOCUMENT_BUTTON = "OpenDocumentButton",
  RX_SUMMARY_BAR_ATTACHMENT = "RxSummaryBarAttachment",
}

export enum TreatmentPlanApplyResourceFilterEntryPoint {
  AUTHOR_FILTER_DROPDOWN = "AuthorFilterDropdown",
  RESOURCE_FILTERS = "ResourceFilters",
  DOCUMENTS_FAVORITE_FILTER = "DocumentsFavoriteFilter",
}

export enum TreatmentPlanPatientAccessDrawerEntryPoint {
  CATALOG_PAGE = "CatalogPage",
  PRODUCT_PAGE = "ProductPage",
  DAILY_PACKS_PAGE = "DailyPacksPage",
  LABS_PAGE = "LabsPage",
  FAVORITES_PAGE = "FavoritesPage",
  TEMPLATES_PAGE = "TemplatesPage",
  RESOURCES_PAGE = "ResourcesPage",
  REVIEW_PLAN_PAGE = "ReviewPlanPage",
}

export enum InOfficeAddToCartEntryPoint {
  PATIENT_HISTORY = "PatientHistory",
  TREATMENT_PLAN = "TreatmentPlan",
  CATALOG = "Catalog",
}

export enum PlanOptimizationEntryPoint {
  PLAN_OPTIMIZATION_DRAWER_ACCORDION = "Plan_Optimization_Drawer_Accordion",
  PLAN_OPTIMIZATION_DRAWER_COMPARISON_TABLE = "Plan_Optimization_Drawer_ComparisonTable",
}

export enum CloseFilterEntryPoint {
  // Disabled naming convention here as the values are computed and should match the enum value
  /* eslint-disable @typescript-eslint/naming-convention */
  TreatmentPlanPage_Resource_HeaderFilterButton = "TreatmentPlanPage_Resource_HeaderFilterButton",
  TreatmentPlanPage_Resource_FilterCloseButton = "TreatmentPlanPage_Resource_FilterCloseButton",
  TreatmentPlanPage_Catalog_HeaderFilterButton = "TreatmentPlanPage_Catalog_HeaderFilterButton",
  TreatmentPlanPage_Catalog_FilterCloseButton = "TreatmentPlanPage_Catalog_FilterCloseButton",
  CatalogPage_Catalog_HeaderFilterButton = "CatalogPage_Catalog_HeaderFilterButton",
  CatalogPage_Catalog_FilterCloseButton = "CatalogPage_Catalog_FilterCloseButton",
  CareCenterCatalogPage_Catalog_HeaderFilterButton = "CareCenterCatalogPage_Catalog_HeaderFilterButton",
  CareCenterCatalogPage_Catalog_FilterCloseButton = "CareCenterCatalogPage_Catalog_FilterCloseButton",
  WholesaleCatalogPage_Catalog_HeaderFilterButton = "WholesaleCatalogPage_Catalog_HeaderFilterButton",
  WholesaleCatalogPage_Catalog_FilterCloseButton = "WholesaleCatalogPage_Catalog_FilterCloseButton",
  CatalogLandingPage_Catalog_HeaderFilterButton = "CatalogLandingPage_Catalog_HeaderFilterButton",
  CatalogLandingPage_Catalog_FilterCloseButton = "CatalogLandingPage_Catalog_FilterCloseButton",
  /* eslint-enable @typescript-eslint/naming-convention */
}

export enum ProductSwapEntryPoint {
  AVATAR_MENU = "AvatarMenu",
  PRODUCT_SWAP_PAGE_TAB = "ProductSwapPage_Tab",
  PLAN_REVIEW_PAGE = "PlanReviewPage",
  PATIENT_PAGE = "PatientPage",
  MPP_PAGE = "MPPPage",
  ACTIVE_SWAP_PAGE = "ActiveSwapPage",
  FAVORITES_PAGE = "FavoritesPage",
  CATALOG_PAGE = "CatalogPage",
  PDP = "PDP",
  ACTIVE_SWAP_PAGE_INDIVIDUAL_BULK_SELECT = "ActiveSwapPage_Individual_BulkSelect",
  ACTIVE_SWAP_PAGE_INDIVIDUAL_SINGLE_SELECT = "ActiveSwapPage_Individual_SingleSelect",
  ACTIVE_SWAP_PAGE_MPP_BULK_SELECT = "ActiveSwapPage_MPP_BulkSelect",
  ACTIVE_SWAP_PAGE_MPP_SINGLE_SELECT = "ActiveSwapPage_MPP_SingleSelect",
  ACTIVE_SWAP_PAGE_PRODUCT_DRAWER_SUGGESTED_PRODUCTS = "ActiveSwapPage_ProductDrawer_SuggestedProducts",
  CATALOG_PAGE_PRODUCT_DRAWER_SUGGESTED_PRODUCTS = "CatalogPage_ProductDrawer_SuggestedProducts",
  FAVORITES_PAGE_PRODUCT_DRAWER_SUGGESTED_PRODUCTS = "FavoritesPage_ProductDrawer_SuggestedProducts",
  PDP_PRODUCT_DRAWER_SUGGESTED_PRODUCTS = "ProductDetailPage_ProductDrawer_SuggestedProducts",
  PLAN_REVIEW_PAGE_PRODUCT_DRAWER_SUGGESTED_PRODUCTS = "PlanReviewPage_ProductDrawer_SuggestedProducts",
  ACTIVE_SWAP_PAGE_CHOOSE_YOUR_SWAP = "ActiveSwapPage_ChooseYourSwap",
  CATALOG_PAGE_CHOOSE_YOUR_SWAP = "CatalogPage_ChooseYourSwap",
  COMPARE_PAGE_CHOOSE_YOUR_SWAP = "ComparePage_ChooseYourSwap",
  FAVORITES_PAGE_CHOOSE_YOUR_SWAP = "FavoritesPage_ChooseYourSwap",
  PDP_CHOOSE_YOUR_SWAP = "ProductDetailPage_ChooseYourSwap",
  PLAN_REVIEW_PAGE_CHOOSE_YOUR_SWAP = "PlanReviewPage_ChooseYourSwap",
  COMPARE_PAGE_SMART_SUGGESTION_CHOOSE_YOUR_SWAP = "ComparePage_SmartSuggestion_ChooseYourSwap",
  PDP_SMART_SUGGESTION_CHOOSE_YOUR_SWAP = "ProductDetailPage_SmartSuggestion_ChooseYourSwap",
}

export enum FavoritesEntryPoint {
  FAVORITE_STAR = "Favorite_Star",
  FAVORITE_CHECKBOX = "Favorite_Checkbox",
  MANAGE_FAVORITES_PAGE = "ManageFavorites_Page",
  ADD_TO_FAVORITES_MODAL = "AddToFavorites_Modal",
}

export enum ViewDraftPlanEntryPoint {
  PLAN_SELECTION_ALL_MY_PATIENT_TILE = "PlanSelection_AllMyPatientTile",
  PLAN_SELECTION_ENTIRE_DISPENSARY = "PlanSelection_EntireDispensary",
  PLAN_SELECTION_ALL_STAFF = "PlanSelection_AllStaff",
  PLAN_SELECTION_ONLY_ME = "PlanSelection_OnlyMe",
  PATIENTS_LIST_PAGE_PATIENT_ROW = "PatientsListPage_PatientRow",
  PATIENTS_LIST_PAGE_BULK_PATIENT_SELECTION = "PatientsListPage_BulkPatientSelection",
  PLAN_WRITER_HEADER_PATIENT_ROW = "PlanWriterHeader_PatientRow",
  PLAN_WRITER_HEADER_BULK_PATIENT_SELECTION = "PlanWriterHeader_BulkPatientSelection",
  PLAN_WRITER_HEADER_STAFF_ROW = "PlanWriterHeader_StaffRow",
  PLAN_WRITER_HEADER_BULK_STAFF_SELECTION = "PlanWriterHeader_BulkStaffSelection",
  PATIENT_PAGE_ORDERS_EMPTY_STATE = "PatientPage_OrdersEmptyState",
  PATIENT_PAGE_PAGE_HEADER = "PatientPage_PageHeader",
  INDIVIDUAL_PLANS_PAGE_HEADER = "IndividualPlansPage_Header",
  LAB_ORDERS_PAGE_HEADER = "LabOrdersPage_Header",
  MULTIPATIENT_PLANS_PAGE_HEADER = "MultiPatientPlansPage_Header",
  TEMPLATE_PLANS_PAGE_HEADER = "TemplatePlansPage_Header",
  PATIENT_PAGE_PRESCRIPTIONS_EMPTY_STATE = "PatientPage_PrescriptionsEmptyState_TreatmentPlanNew",
}

export enum ViewEucationEntryPoint {
  PLANS_SECTION = "PlansSection",
  PROFIT_MARGIN = "ProfitMargin",
  PROFIT_REVENUE_CALCULATOR = "ProfitRevenueCalculator",
  SALES = "Sales",
  ORDERS_PLACED = "OrdersPlaced",
  ORDERING_PATIENTS = "OrderingPatients",
  PLAN_CONVERSION = "PlanConversion",
  FIRST_AUTO_REFILL = "FirstAutoRefill",
  AUTO_REFILL_ORDERS = "AutoRefillOrders",
}

export enum StoreSpotlightClickToNavigateEntryPoint {
  HOME_PAGE = "Homepage",
  PRODUCTS_PAGE = "ProductsPage",
}

export enum FSAssistEntryPoint {
  INTERACTION = "Interaction",
  DEPLETION = "Depletion",
}

type StoreEntryPoint =
  | AddProductAnalyticsEntryPoint
  | NewPatientEntryPoint
  | NewProtocolEntryPoint
  | ProtocolModalEntryPoint
  | AttachSnippetEntryPoint
  | NewTreatmentPlanEntryPoint
  | ViewProductEntryPoint
  | CreatePatientEntryPoint
  | NavigateToPlanPageEntryPoint
  | NewStaffEntryPoint
  | CheckoutStartEntryPoint
  | ShowcaseOnMyWebsiteEntryPoint
  | InOfficeViewCartEntryPoint
  | OpenOnboardingModalEntryPoint
  | SignupEntryPoint
  | NavigateToReferralsPageEntryPoint
  | PillPackEntryPoint
  | LabsStartSetupEntryPoint
  | LabsLaunchEntryPoint
  | ReferralReferPractitionerEntryPoint
  | PayoutsPageEntryPoint
  | PaymentsPageEntryPoint
  | WellevateMigrationEntryPoint
  | ActivateProtocolEntryPoint
  | CloseDrawerEntryPoint
  | IOCAddToCartEntryPoint
  | TreatmentPlanAccessModelEntryPoint
  | EditPlanEntryPoint
  | ViewPlanEntryPoint
  | TreatmentPlanCopyLinkEntryPoint
  | TreatmentPlanDeleteEntryPoint
  | ViewAlternativeProductsEntryPoint
  | BrandAgreementEntryPoint
  | VerifyTaxModalEntryPoint
  | Ten99KEDeliveryEntryPoint
  | SearchApplyEntryPoint
  | LabSearchApplyEntryPoint
  | AttachDocumentEntryPoint
  | SaveDailyPackAsTemplateEntryPoint
  | AddItemToDailyPackEntryPoint
  | StartUpgradeEntryPoint
  | EHRDashboardEntryPoint
  | TreatmentPlanDocumentEntryPoint
  | TreatmentPlanApplyResourceFilterEntryPoint
  | TreatmentPlanPatientAccessDrawerEntryPoint
  | InOfficeAddToCartEntryPoint
  | PlanOptimizationEntryPoint
  | CloseFilterEntryPoint
  | LabViewTestDescriptionEntryPoint
  | LabViewSentTestDetailsEntryPoint
  | LabsJourneyEntryPoint
  | LabsInterpretationEntryPoint
  | ProductSwapEntryPoint
  | FavoritesEntryPoint
  | ViewDraftPlanEntryPoint
  | ViewEucationEntryPoint
  | RemoveProductFromComparisonEntryPoint
  | AddLabKitToCartEntryPoint
  | OptimizedMegaMenuEntryPoint
  | StoreSpotlightClickToNavigateEntryPoint
  | FSAssistEntryPoint;

export type { StoreEntryPoint };
